<template>
	<div class="form-group" :class="{'has-error': hasError}" v-if="!inline">
		<label v-if="label" :for="name" class="col-sm-4 col-md-3 control-label">{{ label }}</label>

		<div class="col-sm-8 col-md-9">
			<!-- REGULAR INPUTS -->
			<div class="input-group">
				<span v-if="prependIcon" class="input-group-addon"><i class="fa fa-fw fa-{{ prependIcon }}"></i></span>
				<input :type="type" :name="name" :id="name" :date-format="dateFormat" class="form-control dateselect" :placeholder="placeholder" v-model="vmodel" v-datepicker="vmodel" :start-date="vmodel" readonly="readonly">
			</div>

			<!-- ERROR -->
			<span v-if="hasError" class="help-block"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</span>
		</div>
	</div>
	<div v-else>
		<label v-if="label" :for="name" class="control-label">{{ label }}</label>
		<input :type="type" :name="name" :id="name" :date-format="dateFormat" class="form-control dateselect" :placeholder="placeholder" v-model="vmodel" v-datepicker="vmodel" :start-date="vmodel" readonly="readonly">
	</div>

</template>

<script>
	import props from './props'
	import events from './events'

	export default {
		props,
		events,

		data() {
			return {
				hasError: false,
				errorMessage: null,
			}
		}
	}
</script>

<style scoped>
	.input-group {
		width: 100%;
	}

	.dateselect {
		background-color: #fff !important;
	}
</style>



// WEBPACK FOOTER //
// input-date.vue?95ed8d84